const SHOWN_PREFIX = 'sb-os-shown:';
const SHOWN_TTL_MS = 60 * 1000;
const FOCUSED_HEAD_START_MS = 120;

function storageKey(tag) {
  return SHOWN_PREFIX + String(tag || 'signalbridge').slice(0, 180);
}

function alreadyShown(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return false;
    const at = Number(raw);
    if (!Number.isFinite(at) || Date.now() - at > SHOWN_TTL_MS) {
      localStorage.removeItem(key);
      return false;
    }
    return true;
  } catch (_) {
    return false;
  }
}

function markShown(key) {
  try {
    if (alreadyShown(key)) return false;
    localStorage.setItem(key, String(Date.now()));
    return true;
  } catch (_) {
    return true;
  }
}

function focusedTabHasHeadStart() {
  try {
    if (typeof document === 'undefined') return false;
    const visible = document.visibilityState === 'visible' && !document.hidden;
    const focused = typeof document.hasFocus === 'function' ? document.hasFocus() : false;
    return Boolean(visible && focused);
  } catch (_) {
    return false;
  }
}

/**
 * One browser profile should show one desktop notification for an event,
 * even when Signal Bridge is open in several tabs.
 */
export async function claimDesktopNotification(tag) {
  const key = storageKey(tag);
  if (alreadyShown(key)) return false;

  if (!focusedTabHasHeadStart()) {
    await new Promise((resolve) => setTimeout(resolve, FOCUSED_HEAD_START_MS));
    if (alreadyShown(key)) return false;
  }

  const lockName = `sb-os:${String(tag || 'signalbridge').slice(0, 180)}`;
  if (typeof navigator !== 'undefined' && navigator.locks?.request) {
    let claimed = false;
    await navigator.locks.request(lockName, { ifAvailable: true }, async (lock) => {
      if (!lock) return;
      claimed = markShown(key);
    });
    return claimed;
  }

  return markShown(key);
}
